// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2LV1T","legacyBtn":"MutateMid_legacyBtn__Me_YN"};